// Data sevice
import axios from 'axios';
import authHeader from './auth-header';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class CategoriesService {
  index() {
    return axios.get(API_URL + 'categories', { headers: authHeader() });
  }
  show(id) {
    return axios.get(API_URL + 'categories/' + id, { headers: authHeader() });
  }
  store(resource) {
    return axios.post(API_URL + 'categories', resource, { headers: authHeader() });
  }
  update(resource) {
    return axios.put(API_URL + 'categories/' + resource.id, resource, { headers: authHeader() });
  }

  delete(resource) {
    return axios.delete(API_URL + 'categories/' + resource.id, { headers: authHeader() });
  }

  getCategories() {
    return axios.get(API_URL + 'categories-public', { headers: authHeader() });
  }

  onlyCategories() {
    return axios.get(API_URL + 'only-categories', { headers: authHeader() });
  }
}

export default new CategoriesService();
